import { defineMessages } from "react-intl";

export default defineMessages({
  notary: {
    id: "aa480023-be68-4226-a46c-c9490fdf76ee",
    defaultMessage: "notary",
  },
  notaryPublic: {
    id: "ebf72a6a-3c15-43bc-950d-93dc02c612f9",
    defaultMessage: "Notary Public",
  },
  verificationMethod: {
    id: "835ffa24-245f-4236-8352-e207933eb4bb",
    defaultMessage: "Knowledge-Based Authentication",
  },

  // Transaction Details Modal
  signingType: {
    id: "7d417353-1889-4c62-ad39-f4877dc1ecf9",
    defaultMessage: "Notarial Act",
  },
  transactionDetails: {
    id: "df4396f7-dba9-4dbb-a221-64a7f2745ebb",
    defaultMessage: "Notarization Details",
  },

  // Notary Portal
  signingDocument: {
    id: "f9526f00-53a1-4579-8375-7818a34421ac",
    defaultMessage: "Notarizing Document",
  },

  // Business Portal
  documentCompleteHistoryMessage: {
    id: "b796d821-3719-443e-9bef-17a518b6d137",
    defaultMessage: "Notarization Complete",
  },
  businessSetupUploadMessage: {
    id: "ce23c0d6-5129-40e7-a5c0-48d8d83df95a",
    defaultMessage: "{upload} the document you need to have notarized",
  },
  businessSetupReceiveMessage: {
    id: "0605b462-66aa-43ff-ae82-511d2336799d",
    defaultMessage: "{receive} your legally notarized documents automatically",
  },
  tryTemplatesModalHeader: {
    id: "cd39d887-aa63-40e2-a55b-d141a423217f",
    defaultMessage: "Notarization request sent!",
  },

  // Signer Portal
  signerDetailsTipWellContent: {
    id: "abbe8ea1-a88e-44a8-b149-ce46a934490e",
    defaultMessage:
      "{requiresNsaMeeting, select, true {Some personal information is required in order to verify your identity. We only use this information to perform legally compliant notarizations, and never share or sell it.} other {Some personal information is required in order to populate the correct information on your documents. We will never share or sell it.}}",
  },
  signatureNoteTitle: {
    id: "621d0764-9705-4ab0-9654-4b5351d751cd",
    defaultMessage: "Signatures are applied during the notary video call",
  },
  signatureNoteText: {
    id: "66c2e43e-5180-403a-9958-657175f6736d",
    defaultMessage: "You will be connected after you verify your identity.",
  },
  annotatableTitle: {
    id: "def654be-e339-4e89-b942-ef46d820c6fb",
    defaultMessage:
      "Fill Out {multipleDocuments, select, true{Documents} other{Document}} Before Notary Meeting",
  },
  nonannotatableTitle: {
    id: "e9c0eb65-bfd1-4d35-a497-173707c52f58",
    defaultMessage:
      "Review {multipleDocuments, select, true{Documents} other{Document}} Before Notary Meeting",
  },
  completeReview: {
    id: "496aef3e-b1d1-4ff7-99b3-90596f76e737",
    defaultMessage: "Complete Review",
  },
  continuePrepare: {
    id: "79b3740f-6c7e-4782-975e-93a3758b06f7",
    defaultMessage: "Continue",
  },
  disclaimerText: {
    id: "fe6d2e09-309f-4f42-a126-2b3e7f54219c",
    defaultMessage:
      "Signatures will be applied during the live notary video call. You will be connected in the last step.",
  },
  techCheckExplainer: {
    id: "07da0273-28b3-4f37-9e18-60c160a848c7",
    defaultMessage:
      "A built-in camera or connected webcam, microphone, speakers or headphones, and a quality internet connection are required to ensure a successful video call with a notary.",
  },
  techCheckExplainerV2: {
    id: "c8bbd976-8c0b-4205-8e44-2335366cc587",
    defaultMessage:
      "Before we connect you with a notary, we'll run some quick tests on your equipment and ask for video and audio permissions.",
  },
  transactionIsComplete: {
    id: "07bda176-7ca6-47d6-893a-71db62e0b920",
    defaultMessage: "Your notarization is complete!",
  },
  signerEnterPaymentDetails: {
    id: "e09ea90a-3f41-430e-85f8-2e32cc41b44e",
    defaultMessage:
      "Please enter your payment details to access {totalCount, plural, one {the notarized document} other {the notarized documents}}.",
  },
  transactionCustomPriceStartsAt: {
    id: "fb201a10-b4d3-40c9-bbb0-e7c21f2f966c",
    defaultMessage: "This notarization starts at {initialPrice}.",
  },
  transactionBasePriceStartsAt: {
    id: "60281a2e-acd9-413a-8590-212c260a880b",
    defaultMessage:
      "This notarization starts at {initialPrice}. Additional seals cost {additionalSealPrice} and signed documents cost {esignedDocPrice}.",
  },
  checkingConnection: {
    id: "cfae0855-f349-4927-a97f-99a25e0fc94d",
    defaultMessage:
      "Checking your internet connection to ensure a quality notary video call. This test will take a few seconds.",
  },
  startAVideoCallWithNotary: {
    id: "75a8699c-e745-442a-926e-b4c18641a3d0",
    defaultMessage: "Up next: Join the notary meeting",
  },
  startAVideoCallWithTestNotary: {
    id: "75a8699c-e745-442a-926e-b4c18641a3d1",
    defaultMessage: "Up next: Join the test notary meeting",
  },
  connectingWithNotary: {
    id: "2a00d144-faae-4558-858b-aef37dcf7f86",
    defaultMessage: "Finding the next available notary...",
  },
  transactionPaidForBy: {
    id: "5caa53c2-be43-4340-8996-06096a0bfb8c",
    defaultMessage: "{organizationName} is paying for this notarization.",
  },
  transactionMayBeBilled: {
    id: "a3a25f13-9cb7-45cd-b459-475032913b9b",
    defaultMessage:
      "{organizationName} won't be collecting a payment during the session, but you may be billed afterward.",
  },
  signerSessionExpired: {
    id: "6be772aa-2121-4569-8700-91aa7c8101aa",
    defaultMessage:
      "{requiresNsaMeeting, select, true {You must verify your identity within 2 hours of connecting with a notary.} other {}} Please re-enter your information to continue.",
  },
  callWillBeRecorded: {
    id: "84c356c4-994e-4118-8138-fdda7859cceb",
    defaultMessage:
      "Audio and video will be recorded during the notary meeting as proof of notarization.",
  },
  notarizePlatformMessage: {
    id: "8f82b3b1-bd6b-472e-b149-74e1fb2f05a9",
    defaultMessage:
      "Notarize connects you by video with a Notary Public to perform legal online notarization — no matter where you're located. {learnMore}",
  },
  handleTransactionSentWelcome: {
    id: "3026b377-d6d9-4c91-abca-a9b9002052db",
    defaultMessage:
      "Welcome to {companyName}! {organizationName} has sent you {totalCount, plural, one {a document} other {documents}} to {requiresNsaMeeting, select, true {notarize online} other {sign}}",
  },
  handleTransactionGenericWelcome: {
    id: "bf73a599-f798-4868-a977-d60790276c1b",
    defaultMessage: "Welcome to {companyName}. Legally notarize your documents online. Anytime.",
  },
  organizationSentDocumentForSigning: {
    id: "ec4d8740-c52a-4517-8cd0-21bf55c741a4",
    defaultMessage:
      "{organizationName} has sent you {totalCount, plural, one {a document} other {documents}} to notarize online.",
  },
  getDocumentsSignedAnytime: {
    id: "ee064dc9-899b-458d-ac66-ae3c420c5a4d",
    defaultMessage: "Legally notarize your documents online. Anytime.",
  },
  connectWithNotary: {
    id: "46a91f8e-676b-4fde-b8bc-a439dab85ad1",
    defaultMessage: "{connect} with a Notary Public over live video",
  },
  connectWithNotaryFromDevice: {
    id: "d1ae0688-1165-4fb5-9f72-d21ffc14f4a0",
    defaultMessage:
      "Connect with a Notary Public over live video from your computer, tablet, or phone.",
  },
  notariesAlwaysOnline: {
    id: "97cdb9dc-f65f-4bfd-b0cb-ece145c1be2d",
    defaultMessage: "Notaries{break}always online",
  },
  getItSigned: {
    id: "8165c740-a394-43af-892b-cdde49c6fa7b",
    defaultMessage: "Notarize it from your phone instead",
  },
  bitLandingDocumentMessage: {
    id: "d8b049c0-4699-4fba-adf1-1e12afe32b0a",
    defaultMessage:
      "{brandName} has sent you {totalCount, plural, one {a document} other {documents}} to {requiresNsaMeeting, select, true {notarize} other {sign}} online",
  },
  bitLandingExperimentDocumentMessage: {
    id: "83bb4b1a-ba05-463c-b285-31912b72c692",
    // This message may need to change in this case
    defaultMessage:
      "Verify your identity in a few steps and we'll instantly connect you with a certified notary over video call",
  },
  bitLandingDocumentMessageFreeService: {
    id: "e789cb4d-f831-4ea6-80b9-4848ed43d78e",
    defaultMessage: "This service will be free for you.",
  },
  bitLandingGetStartedMessage: {
    id: "a39885dc-40de-4411-9951-7ba76d0ad425",
    defaultMessage: "{requiresNsaMeeting, select, true {Get it notarized} other {Review And Sign}}",
  },
  bitLandingWelcomeSubheader: {
    id: "bc84a149-90ae-48da-ae2a-0aea8ea7f993",
    defaultMessage: "Legally Notarize Your Documents Online in Minutes",
  },
  signerShareWithAnyone: {
    id: "99aa9d75-e316-43d8-9383-651947543c7c",
    defaultMessage: "{share} your legally notarized documents with anyone.",
  },
  signatureAnnotationModalMessage: {
    id: "b54720f2-27ba-41af-a072-b3956886f40f",
    defaultMessage:
      "You will be connected to a notary in the last step, after you verify your identity.",
  },
  guestUploadHeaderV1: {
    id: "8232da9a-72ce-4535-86e9-2e5235c8c926",
    defaultMessage: "Get Started with Notarization",
  },
  guestUploadSubheaderV1: {
    id: "9e1acfb2-2679-4c49-8153-a8c8210b9025",
    defaultMessage: "Upload a document to connect with a live notary within minutes.",
  },
  guestUploadAppDownloadInfo: {
    id: "f2239c9f-98b7-4361-97bf-4256cd9a2328",
    defaultMessage:
      "Take pictures of your paper document and get your document notarized using our mobile or tablet app.",
  },
  guestUploadAffiliateTxnAppDownloadInfoWebScan: {
    id: "ef9016aa-eece-490b-9c71-d3bc157b7994",
    defaultMessage: "Take pictures of your paper document using your preferred mobile browser.",
  },
  ps1583InstructionsHeader: {
    id: "2271f944-77cb-4a9f-8863-14753be162be",
    defaultMessage: "Before we connect you with a notary, add IDs",
  },

  // Verify Portal
  verifyRetrievalResultSuccess: {
    id: "65a54778-8585-4007-aa0f-c949accd2cb7",
    defaultMessage: "Success! This document was notarized!",
  },
});
